import React from 'react';
import {Create} from 'react-admin';
import {BankForm} from './BankForm';

export const BankCreate = (props: unknown): React.ReactElement => <Create {...props}>
    <BankForm {...props}/>
</Create>;

